import { BUBBLE_LATERAL_DRIFT, BUBBLE_RISE_SPEED, PREDATOR_GLOW_RADIUS_MULT } from './configs';
export interface BubbleState { x: number; y: number; radius: number; drift: number; age: number; lifetime: number; alpha: number }
export const finitePositive = (value: number, fallback: number): number =>
  Number.isFinite(value) && value > 0 ? value : fallback;
export const createBubble = (
  random: () => number, width: number, height: number,
): BubbleState => {
  const safeWidth = Math.max(1, width);
  const safeHeight = Math.max(1, height);
  const radius = finitePositive(random(), 1) * 6;
  return {
    x: random() * safeWidth,
    y: safeHeight + radius + random() * 20,
    radius,
    drift: (random() - 0.5) * BUBBLE_LATERAL_DRIFT,
    age: 0,
    lifetime: Math.max(0.1, finitePositive(random(), 1) * 4 + 2),
    alpha: 0.65,
  };
};
export const updateBubble = (bubble: BubbleState, deltaSeconds: number, width = 390): BubbleState => {
  const dt = Number.isFinite(deltaSeconds) ? Math.max(0, Math.min(deltaSeconds, 0.1)) : 0;
  const age = bubble.age + dt;
  const life = Math.max(0.1, bubble.lifetime);
  return {
    ...bubble,
    x: Math.max(0, Math.min(Math.max(1, width), bubble.x + bubble.drift * dt)),
    y: bubble.y - finitePositive(BUBBLE_RISE_SPEED, 28) * dt,
    age,
    alpha: Math.max(0, 1 - age / life),
  };
};
export const seaweedSway = (time: number, phase: number, amplitude = 14, frequency = 0.8): number =>
  Math.sin(time * frequency * Math.PI * 2 + phase) * amplitude;
export const lightRayOffset = (
  playerX: number, viewportWidth: number, strength = 0.075,
): number => {
  const center = Math.max(1, viewportWidth) / 2;
  return Math.max(-1, Math.min(1, (playerX - center) / center)) * strength;
};
export const predatorPulseAlpha = (time: number, pulseSeconds = 1.2): number =>
  0.45 + 0.35 * (0.5 + 0.5 * Math.sin(time * Math.PI * 2 / Math.max(0.1, pulseSeconds)));
export const predatorGlowRadius = (fishRadius: number): number =>
  Math.max(1, fishRadius) * PREDATOR_GLOW_RADIUS_MULT;
export const isLargerFish = (playerLevel: number, fishLevel: number): boolean => fishLevel > playerLevel;
export const isReducedMotion = (matchMedia?: (query: string) => { matches: boolean }): boolean => {
  try {
    return matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false;
  } catch {
    return false;
  }
};